"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * oai-api
 * The OptionsAI API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: tech@options.ai
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const runtime = require("../runtime");
const models_1 = require("../models");
/**
 *
 */
class AccountApi extends runtime.BaseAPI {
    /**
     * Get brokerage account information
     */
    getAccountRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/accounts`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.AccountFromJSON(jsonValue));
        });
    }
    /**
     * Get brokerage account information
     */
    getAccount() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getAccountRaw();
            return yield response.value();
        });
    }
    /**
     * Get the current account balance
     */
    getAccountBalanceRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/accounts/balance`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.RealTimeBalanceFromJSON(jsonValue));
        });
    }
    /**
     * Get the current account balance
     */
    getAccountBalance() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getAccountBalanceRaw();
            return yield response.value();
        });
    }
    /**
     * Get account trading history
     */
    getAccountHistoryRaw(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.startDate === null || requestParameters.startDate === undefined) {
                throw new runtime.RequiredError('startDate', 'Required parameter requestParameters.startDate was null or undefined when calling getAccountHistory.');
            }
            if (requestParameters.endDate === null || requestParameters.endDate === undefined) {
                throw new runtime.RequiredError('endDate', 'Required parameter requestParameters.endDate was null or undefined when calling getAccountHistory.');
            }
            const queryParameters = {};
            if (requestParameters.startDate !== undefined) {
                queryParameters['startDate'] = requestParameters.startDate;
            }
            if (requestParameters.endDate !== undefined) {
                queryParameters['endDate'] = requestParameters.endDate;
            }
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/accounts/history`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.AccountHistoryFromJSON(jsonValue));
        });
    }
    /**
     * Get account trading history
     */
    getAccountHistory(requestParameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getAccountHistoryRaw(requestParameters);
            return yield response.value();
        });
    }
    /**
     * Get latest account trading limits
     */
    getAccountTradingLimitRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/accounts/trading-limits`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.UserBalanceFromJSON(jsonValue));
        });
    }
    /**
     * Get latest account trading limits
     */
    getAccountTradingLimit() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getAccountTradingLimitRaw();
            return yield response.value();
        });
    }
    /**
     * Get account snapshot
     */
    getAccountsSnapshotRaw() {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = typeof token === 'function' ? token("bearerAuth", []) : token;
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/snapshots/accounts`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            });
            return new runtime.JSONApiResponse(response, (jsonValue) => models_1.AccountsSnapshotFromJSON(jsonValue));
        });
    }
    /**
     * Get account snapshot
     */
    getAccountsSnapshot() {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getAccountsSnapshotRaw();
            return yield response.value();
        });
    }
}
exports.AccountApi = AccountApi;
